import React, { useEffect, useState } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import './Timeline.css';
import { db } from '../firebase';
import { doc, getDoc } from "firebase/firestore";
import { CgRing } from "react-icons/cg";
import { MdChurch, MdRestaurant } from 'react-icons/md';
import { BiSolidDrink } from "react-icons/bi";
import { FaGlassCheers } from "react-icons/fa";
import { GiPartyPopper } from "react-icons/gi";
import { GiExitDoor } from "react-icons/gi";
import { CardSimple } from './CardSimple';
import { StyleSheet, Text} from 'react-native';
import properties from '../properties.json' 
import imagenSalon from '../assets/salon.avif';
import imagenIglesia from '../assets/iglesia.avif';

export function Timeline() {

    const [info, setInfo] = useState(null);

    useEffect(() => {
        const getInfo = async () => {
        const docRef = doc(db, "datos-evento", "info");
        const docSnap = await getDoc(docRef);
        setInfo(docSnap.data());
        }
    getInfo();
  }, []);

    return (
        <div id="sectionItinerario" className="containerTimeLine">
            <VerticalTimeline>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="6 de Febrero 2027"
                    contentArrowStyle={{ borderRight: '7px solid ' + properties.backgroudPrimaryColor }}
                    contentStyle={{ background: properties.backgroudPrimaryColor}}
                    iconStyle={{ background: properties.backgroudPrimaryColor, color: '#fff' }}
                    icon={<CgRing />}
                >
                    <Text style={styles.mainCardTitle}>Boda Fer & Jaime</Text>
                    <p style={{color: '#ffffff', fontSize: 17, textAlign: 'justify'}}>
                        Para nosotros es muy importante que nos puedas acompañar en esta fecha tan especial. Te compartimos el detalle de este gran día.
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date={info?.iglesia?.time}
                    contentArrowStyle={{ borderRight: '7px solid ' + properties.backgroundSecondaryColor }}
                    contentStyle={{ background: properties.backgroundSecondaryColor}}
                    iconStyle={{ background: properties.backgroudPrimaryColor, color: '#fff' }}
                    icon={<MdChurch />}
                >
                    {(info ? CardSimple(info.iglesia,imagenIglesia): 'Cargando información...')}
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date={info?.salon?.time}
                    contentArrowStyle={{ borderRight: '7px solid ' + properties.backgroundSecondaryColor }}
                    contentStyle={{ background: properties.backgroundSecondaryColor}}
                    iconStyle={{ background: properties.backgroudPrimaryColor, color: '#fff' }}
                    icon={<BiSolidDrink />}
                >
                    {(info ? CardSimple(info.salon,imagenSalon): 'Cargando información...')}
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="20:00 - 21:00 hrs"
                    contentArrowStyle={{ borderRight: '7px solid ' + properties.backgroundSecondaryColor }}
                    contentStyle={{ background: properties.backgroundSecondaryColor}}
                    iconStyle={{ background: properties.backgroudPrimaryColor, color: '#fff' }}
                    icon={<MdRestaurant />}
                >
                    <h2 className="vertical-timeline-element-title">Cena</h2>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="21:00 - 21:15 hrs"
                    contentArrowStyle={{ borderRight: '7px solid ' + properties.backgroundSecondaryColor }}
                    contentStyle={{ background: properties.backgroundSecondaryColor}}
                    iconStyle={{ background: properties.backgroudPrimaryColor, color: '#fff' }}
                    icon={<FaGlassCheers />}
                >
                    <h2 className="vertical-timeline-element-title">Brindis</h2>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="21:15 - 02:00 hrs"
                    contentArrowStyle={{ borderRight: '7px solid ' + properties.backgroundSecondaryColor }}
                    contentStyle={{ background: properties.backgroundSecondaryColor}}
                    iconStyle={{ background: properties.backgroudPrimaryColor, color: '#fff' }}
                    icon={<GiPartyPopper />}
                >
                    <h2 className="vertical-timeline-element-title">¡¡Fiesta!!</h2>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="02:00 - 02:30 hrs"
                    contentArrowStyle={{ borderRight: '7px solid ' + properties.backgroundSecondaryColor }}
                    contentStyle={{ background: properties.backgroundSecondaryColor}}
                    iconStyle={{ background: properties.backgroudPrimaryColor, color: '#fff' }}
                    icon={<GiExitDoor />}
                >
                    <h2 className="vertical-timeline-element-title">Cierre</h2>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </div>
    );
}

const styles = StyleSheet.create({
    mainCardTitle: {
    fontSize: 40,
    fontWeight: '600',
    color: '#1f2937',
    'font-family': "Parisienne",
  }
})
